import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import numeral from 'numeral';

interface ShiftAtomSoufflingState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    souffling_list: any[];
    shift_souffling_list: any[];
    plan_list: any[];
    schemas: any;
}

const state: ShiftAtomSoufflingState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    souffling_list: [],
    shift_souffling_list: [],
    plan_list: [],
    schemas: {}
};

const initState: any = cloneDeep(state);

const GET_PLAN_LINES_LIST = 'GET_PLAN_LINES_LIST';
const GET_LINES_SOUFFLING_LIST = 'GET_LINES_SOUFFLING_LIST';
const GET_SHIFT_SOUFFLING_LIST = 'GET_SHIFT_SOUFFLING_LIST';

const mapper: any = {
  '[[рецепт.кол-воды]]': (data: any) => {
    const _temp = parseFloat(data.temp)
    const borders = (data.water_borders && data.water_borders.borders ? data.water_borders.borders : []).filter((item: any, idx: number) => {
      return item.temp < _temp;
    });
    const coef = borders.length ? borders[borders.length - 1].coef : 0

    return numeral((parseFloat(data.water) / coef + data.plus_water) / 1000).format('0.00')
  }
}
const format_text = (text: any, data: any) => {
  const _t = {text: text}
  Object.keys(mapper).map((key: any) => {
    if (_t.text.indexOf(key) > -1) {
      _t.text = _t.text.replace(key, mapper[key](data))
    }
  })
  return _t.text
}

export const actions: ActionTree<ShiftAtomSoufflingState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    weightCalc({ commit, getters, dispatch, state }, plan) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('CALC')
              .raw('documents.calculate')
              .action({plan})
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('CALC').getContent();

              resolve(exportOpContent.result);
          }));
      })
    },
    loadPlans({ commit }, { documentId }) {
      const vm = (this as any)._vm;

      commit('START_LOADING');

      state.documentId = documentId;

      return new Promise((resolve, reject) => {
        vm.$db([
          vm.$q(GET_PLAN_LINES_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sfpa.id',
                  plan_id: 'sacp.id',
                  shift_id: 'sfpa.shift_id',
                  wash_id: 'spw.id',
                  equipment_id: 'spw.equipment_id',
                  clear_filling: 'spw.clear_filling',
                  line_id:  {$case: [
                    [
                      {$null: ['sacp.line_id']},
                      'wash_line.id'
                    ],
                    [
                      {$: true},
                      'sacp.line_id'
                    ]
                  ]},
                  is_done: {$case: [
                    [
                      {$null: ['sacp.id']},
                      'spw.is_done'
                    ],
                    [
                      {$: true},
                      'sacp.is_done'
                    ]
                  ]},
                  done_time: {$case: [
                    [
                      {$null: ['sacp.id']},
                      'spw.done_time'
                    ],
                    [
                      {$: true},
                      'sacp.done_time'
                    ]
                  ]},
                  number: 'sfpa.number',
                  product_name: {
                    $case: [
                      [
                        {$null: ['pp.name']},
                        {$concat: [{$: 'Мойка'}, {$: ' '}]}
                      ],
                      [
                        {
                          "$": true
                        },
                        'pp.name'
                      ]
                    ]
                  },
                  target_acidity: 'pp.target_acidity',
                  journals: {
                    $array_agg: {
                      $obj: {
                        acidity_1: 'sja.acidity_1',
                        acidity_2: 'sja.acidity_2',
                        acidity_3: 'sja.acidity_3',
                        acidity_4: 'sja.acidity_4',
                        palet_weight: 'sja.palet_weight',
                      }
                    }
                  },
                  strach_add: 'pp.strach_add',
                  ingredients: {
                    $array_agg: {
                      $obj: {
                        id: "vi.id",
                        name: "vi.name",
                        type: "vi.type",
                        code: "vi.code",
                        value_time_1: "ppi.value_time_1",
                        value_time_2: "ppi.value_time_2",
                        value_time_3: "ppi.value_time_3",
                        value_time_4: "ppi.value_time_4",
                        value_time_5: "ppi.value_time_5",
                        value_time_6: "ppi.value_time_6",
                        value_time_7: "ppi.value_time_7",
                      }
                    }
                  },
                  common_weight: 'items.common_weight',
                  quantites: 'items.quantites',
                },
                from: 's:shift_full_plan_atom',
                from_as: 'sfpa',
                joins: [
                  {
                    join: 's:shift_atom_coock_plan',
                    type: 'left',
                    as:   'sacp',
                    on: {
                      $and: [
                        {$eq: ['sfpa.plan_id', 'sacp.id']},
                        {$null: ['sacp.deleted_at']}
                      ]
                    }
                  },
                  {
                    join: 's:produced_products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['sacp.product_id', 'pp.id']
                    }
                  },
                  {
                    join: 's:produced_product_ingredients',
                    type: 'left',
                    as:   'ppi',
                    on: {
                      $eq: ['ppi.produced_product_id', 'pp.id']
                    }
                  },
                  {
                    join: 's:voc_ingredients',
                    type: 'left',
                    as:   'vi',
                    on: {
                      $and: [
                        {$eq: ['ppi.ingredient_id', 'vi.id']},
                        {$eq: ['vi.is_atom', {$: true}]}
                      ]
                    }
                  },
                  {
                    join: 's:shift_journal_atom',
                    type: 'left',
                    as:   'sja',
                    on: {
                      $eq: ['sja.plan_id', 'sacp.id']
                    }
                  },
                  {
                    join: {
                      columns: {
                        coock_plan_id: 'sacpi.coock_plan_id',
                        common_weight: {$sum: 'sacpi.weight'},
                        quantites: {
                          $array_agg: {
                            $obj: {
                              quantity: 'sacpi.quantity',
                              extract_time: 'svf.extract_time',
                            }
                          }
                        }
                      },
                      from: 's:shift_atom_coock_plan_items',
                      from_as: 'sacpi',
                      joins: [
                        {
                          join: 's:shift_fact_vdp',
                          type: 'left',
                          as:   'svf',
                          on: {
                            $eq: ['svf.shift_plan_id', 'sacpi.vdp_plan_id']
                          }
                        },
                      ],
                      page: 0,
                      page_size: 10000,
                      groups: [
                        'sacpi.coock_plan_id'
                      ]
                    },
                    type: 'left',
                    as: 'items',
                    on: { $eq: ['items.coock_plan_id', 'sacp.id'] },
                  },
                  {
                    join: 's:shift_plan_washing',
                    type: 'left',
                    as:   'spw',
                    on: {
                      $eq: ['sfpa.wash_id', 'spw.id']
                    }
                  },
                  // {
                  //   join: 's:voc_volumes_washings',
                  //   type: 'left',
                  //   as:   'vvw',
                  //   on: {
                  //     $eq: ['vvw.id', 'spw.washing_id']
                  //   }
                  // },
                  {
                    join: {
                      columns: {
                        id: 'vl.id',
                      },
                      from: 's:voc_lines',
                      from_as: 'vl',
                      where: {
                        $eq: [`vl.templates`, {$: 'wash'}]
                      },
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'wash_line',
                    on: { $eq: ['sfpa.wash_id', 'spw.id'] }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['sfpa.number']}
                ],
                groups: [
                  'sfpa.id',
                  'sacp.id',
                  'spw.id',
                  'sacp.line_id',
                  'wash_line.id',
                  'sfpa.shift_id',
                  'sacp.is_done',
                  'sacp.done_time',
                  'sfpa.number',
                  'pp.name',
                  'pp.target_acidity',
                  'items.common_weight',
                  'items.quantites',
                  'pp.strach_add'
                ],
                where: {
                  $and: [
                    {$or: [
                      {$eq: [`sfpa.shift_id`, {$: documentId}]},
                      // {$not: [ { $null: [`prev_spv.id`] } ]},
                    ]},
                    {$null: [`sacp.deleted_at`, ]},
                  ],
                }
              }),
        ]).then((result: ServerResult) => {
          const opPlanListResult = result.getOperation(GET_PLAN_LINES_LIST);

          const groupsByNumber = opPlanListResult.getContent().documents.reduce((prev: any, item: any) => {
            if (item.number && (item.plan_id || item.wash_id)) {
              const _key = item.number.split('.')[0] + '-' + item.shift_id;
              if (!prev[_key]) {
                prev[_key] = []
              }
              prev[_key].push(item.plan_id ? item.plan_id : item.wash_id);
            }
            return prev
          }, {})

          const planList = opPlanListResult.getContent().documents.map((item: any) => {
            const _key = item.number.split('.')[0] + '-' + item.shift_id;
            item.plans = groupsByNumber[_key];
            return item;
          }).filter((item: any) => {
            return item.number.split('.').length == 1 && (item.plan_id || item.wash_id)
          })
          state.plan_list = planList;
          resolve(null);
        })
      })
    },

    loadData({ commit, getters, dispatch, state }, { documentId, lineId, equipmentId, types }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        commit('START_LOADING');

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q('SCHEMA_SFV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_fact_vdp`
                }),
            vm.$q('SCHEMA_SJV')
                .raw('schemas.get')
                .action({
                    id: `s:shift_journal_vdp`
                }),
            vm.$q(GET_LINES_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'vls.id',
                  text: 'vls.text',
                  equipment_id: 'vls.equipment_id',
                  with_button: 'vls.with_button',
                  button_label: 'vls.button_label',
                  action: 'vls.action',
                  field_taget: 'vlsf.target',
                  field_type: 'vlsf.type',
                  field_label: 'vlsf.label',
                  field_id: 'vlsf.id',
                },
                from: 's:voc_lines_souffling',
                from_as: 'vls',
                joins: [
                  {
                    join: 's:voc_lines_souffling_fields',
                    type: 'left',
                    as:   'vlsf',
                    on: {
                      $eq: ['vls.field_id', 'vlsf.id']
                    }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['vls.position']},
                  {$asc: ['vls.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`vls.line_id`, {$: lineId}]},
                    ...(equipmentId ? [{$eq: [`vls.equipment_id`, {$: equipmentId}]}] : []),
                    {$in: [`vls.type`, {$: types}]},
                  ]
                }
              }),

            vm.$q(GET_SHIFT_SOUFFLING_LIST)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'ss.id',
                  souffling_id: 'ss.souffling_id',
                  shift_plan_id: 'ss.shift_atom_coock_plan_id',
                  is_accepted: 'ss.is_accepted',
                  manager_name: 'employee.name',
                  updated_at: 'ss.updated_at',
                },
                from: 's:shift_souffling',
                from_as: 'ss',
                joins: [
                  {
                    join: 's:employees',
                    type: 'left',
                    as:   'employee',
                    on: {
                      $eq: ['employee.id', 'ss.manager_id']
                    }
                  },
                  {
                    join: {
                      columns: {
                        id: 'base.id',
                      },
                      from: 's:shifts',
                      from_as: 's',
                      joins: [
                        {
                          join: 's:shifts',
                          type: 'left',
                          as:   'base',
                          on: {
                            $and: [
                              { $lt: ['base.real_end_time', 's.real_begin_time']},
                              { $eq: ['base.line_id', 's.line_id']},
                              { $not: [ { $null: [`base.real_end_time`] } ] }
                            ]
                          }
                        },
                      ],
                      where: {
                        $eq: [`s.id`, {$: documentId}]
                      },
                      order: [
                        {$desc: ['base.real_end_time']}
                      ],
                      page: 0,
                      page_size: 1
                    },
                    type: 'left',
                    as: 'prev_spv',
                    on: { $eq: ['ss.shift_id', 'prev_spv.id'] }
                  },
                ],
                page_size: 10000,
                page: 1,
                order: [
                  {$asc: ['ss.id']}
                ],
                where: {
                  $or: [
                    {$eq: [`ss.shift_id`, {$: documentId}]},
                    {$not: [ { $null: [`prev_spv.id`] } ]},
                  ],
                }
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_LINES_SOUFFLING_LIST);
            const opListResult = result.getOperation(GET_SHIFT_SOUFFLING_LIST);

            if (!opRelResult.hasError() && !opRelResult.hasError()) {
              state.shift_souffling_list = opListResult.getContent().documents
              state.schemas.shift_fact_vdp = result.getOperation('SCHEMA_SFV').getContent().schema
              state.schemas.shift_journal_vdp = result.getOperation('SCHEMA_SJV').getContent().schema

              const shift_souffling: any = {}
              state.shift_souffling_list.map((item: any) => {
                if (!shift_souffling[item.shift_plan_id]) {
                  shift_souffling[item.shift_plan_id] = {}
                }
                shift_souffling[item.shift_plan_id][item.souffling_id] = item
              })
              state.souffling_list = state.plan_list.reduce((prev: any, plan: any) => {
                const journal = plan.journals.length > 0 ? plan.journals[plan.journals.length - 1] : null;
                prev[plan.id] = opRelResult.getContent().documents.map((item: any) => {
                  const _new_item = cloneDeep(item)
                  _new_item.text = format_text(_new_item.text, plan.fields)
                  if (shift_souffling[plan.plan_id] && shift_souffling[plan.plan_id][_new_item.id]) {
                    _new_item.shift_souffling = shift_souffling[plan.plan_id][_new_item.id]
                  }
                  _new_item.shift_plan_id = plan.shift_plan_id
                  _new_item.plans = plan.plans
                  _new_item.value = null
                  _new_item.message = ''
                  if (plan.target_acidity > 0 && _new_item.field_taget && ['acidity_1', 'acidity_2', 'acidity_3', 'acidity_4'].includes(_new_item.field_taget.field_name)) {
                    let milkstab: any = plan.ingredients.filter((item: any) => {
                      return item.code == 'milkstab'
                    })
                    milkstab = milkstab.length > 0 ? parseFloat(milkstab[0].value_time_1) : 0
                    const max = Math.max(...(Object.values(journal).slice(0, 4) as number[]))
                    if (plan.target_acidity > max) {
                      if (journal.acidity_1 > 0 && !journal.acidity_2) {
                        _new_item.message = "Добавить половину MILKSTAB-100: " + (numeral(milkstab / 2).format('0.00')) + '%'
                      } else if (journal.acidity_1 > 0 && !journal.acidity_4) {
                        _new_item.message = "Добавить MILKSTAB-100: " + milkstab + '%'
                      }
                    }
                    if (journal.acidity_3 > 0) {
                      _new_item.field_taget.field_name = 'acidity_4'
                    } else if (journal.acidity_2 > 0) {
                      _new_item.field_taget.field_name = 'acidity_3'
                    } else if (journal.acidity_1 > 0) {
                      _new_item.field_taget.field_name = 'acidity_2'
                    }
                  }
                  return cloneDeep(_new_item)
                })
                return prev
              }, {})
            }
            resolve(null);
            commit('LOADED_SUCCESS');
          });
        })
    },

    setAccepted({state, dispatch, commit, rootState}, {documentId, item, plan}) {
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        commit('START_LOADING');
        let saveQuery = null;
        if (item.shift_souffling) {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .update(item.shift_souffling.id, {
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        } else {
            saveQuery = vm.$q('SHIFT_DATA_SAVE')
                .create('s:shift_souffling', {
                  shift_id: documentId,
                  souffling_id: item.id,
                  shift_atom_coock_plan_id: plan.plan_id,
                  shift_plan_washing_id: plan.wash_id,
                  is_accepted: true,
                  manager_id: (rootState as any).ubic.actor.document.id
                })
        }
        const queries: any[] = [];
        let field_name: any = null;
        if (item.field_taget) {
          field_name = item.field_taget.field_name;
          if (!['acidity_1', 'acidity_2', 'acidity_3', 'acidity_4'].includes(item.field_taget.field_name)) {
            queries.push(saveQuery)
          } else if (item.field_taget.field_name == 'acidity_4' || plan.target_acidity <= item.value) {
            queries.push(saveQuery)
          }
        }  else {
          queries.push(saveQuery)
        }
        if (item.action == 'field' && item.field_id) {
          item.plans.map((plan_id: any) => {
            if (plan_id) {
              queries.push(
                plan_id.startsWith('d:shift_plan_washing') ?
                vm.$q("SET_SOUFFLINGVALUE-" + plan_id)
                .raw('set_wash_soufling_value')
                .action({
                  field_id: item.field_id,
                  plan_washing_id: plan.wash_id,
                  shift_id: documentId,
                  value: item.value,
                  field_name: field_name,
                }) :
                vm.$q("SET_SOUFFLINGVALUE-" + plan_id)
                  .raw('set_atom_soufling_value')
                  .action({
                    field_id: item.field_id,
                    shift_atom_coock_plan_id: plan.plan_id,
                    shift_id: documentId,
                    value: item.value,
                    field_name: field_name,
                  })
              )
            }
          })
          vm.$db(queries).then((result: ServerResult) => {
            resolve(null)
            commit('LOADED_SUCCESS');
          });
        } else if(item.action == 'none') {
          vm.$db(queries).then((result: ServerResult) => {
            resolve(null)
            commit('LOADED_SUCCESS');
          });
        } else if(item.action == 'calc') {
          dispatch('weightCalc', plan).then((result: any) => {
            const fields_mapper: any = {
              sum_backet: 'clots_weight',
            }
            Object.keys(result).map((key: string) => {
              const value = (key == 'sum_backet') ? result[key].inner[1].value :  result[key].value 
              if (key != 'null') {
                item.plans.map((plan_id: any) => {
                  if (fields_mapper[key]) {
                    queries.push(
                      vm.$q("SET_SOUFFLINGVALUE-" + plan_id + key)
                        .raw('set_atom_soufling_value')
                        .action({
                          field_id: 'd:voc_lines_souffling_fields:91',
                          shift_atom_coock_plan_id: plan_id,
                          shift_id: documentId,
                          value: value,
                          field_name: fields_mapper[key],
                        })
                    )
                  } else if (result[key].ingredient){
                    queries.push(
                      vm.$q("SET_SOUFFLINGVALUE-" + plan_id + key)
                        .raw('set_atom_soufling_value')
                        .action({
                          field_id: 'd:voc_lines_souffling_fields:91',
                          shift_atom_coock_plan_id: plan_id,
                          shift_id: documentId,
                          value: value,
                          field_name: fields_mapper[key],
                          ingredient_id: result[key].ingredient.id,
                        })
                    )
                  }
                })
              }
            })
            if (queries.length) {
              vm.$db(queries).then((result: ServerResult) => {
                resolve(null)
              });
            } else {
              resolve(null)
            }
          })
        } else {
          if (queries.length) {
            vm.$db(queries).then((result: ServerResult) => {
              resolve(null)
            });
          } else {
            resolve(null)
          }
        }
      })
    },

    setDone({state, commit}, {plan, clear_filling}) {
      console.log(plan)
      const vm = (this as any)._vm;
      return new Promise((resolve, reject) => {
        let done_time = moment()

        if (plan.ignore_done_delay) {
          done_time = done_time.add(plan.done_delay.secs, 'seconds');
        }

        const done_fields: any = {
          is_done: true,
          done_time: done_time.utc().local().format('YYYY-MM-DD HH:mm:ss')
        };
        // clear_filling — колонка shift_plan_washing: только для строк мойки
        if (!plan.plan_id) {
          done_fields.clear_filling = clear_filling !== false;
        }
        const queries: any[] = [
          vm.$q('SHIFT_DATA_SAVE')
                .update((plan.plan_id ? plan.plan_id : plan.wash_id), done_fields)
        ];
        commit('START_LOADING');
        vm.$db(queries).then((result: ServerResult) => {
          resolve(null)
          commit('LOADED_SUCCESS');
        });
      })

    },

    setItemValue({state, commit}, {plan_id, index, newValue}) {
      commit('SET_ITEM_VALUE', {plan_id, index, newValue})
    }
};

export const mutations: MutationTree<ShiftAtomSoufflingState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  SET_ITEM_VALUE: (state, {plan_id, index, newValue}) => {
    console.log('SET_ITEM_VALUE', state.souffling_list[plan_id], plan_id, index, newValue)
    state.souffling_list[plan_id][index].value = newValue
  }
};

export const getters: GetterTree<ShiftAtomSoufflingState, RootState> = {
  // shift_souffling_list: (state: ShiftAtomSoufflingState) => {
  //   const shift_souffling: any = {}
  //   state.shift_souffling_list.map((item: any) => {
  //     shift_souffling[item.souffling_id] = item
  //   })

  //   return state.souffling_list.map((item: any) => {
  //     if (shift_souffling[item.id]) {
  //       item.shift_souffling = shift_souffling[item.id]
  //     }
  //     return item
  //   })
  // }
};

export const STORE_KEY = '$_shift_atom_souffling_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
